/* eslint-disable */
import React from 'react';

const HtmlComp = ({ htmlString }) => {
    return (
        <div dangerouslySetInnerHTML={{ __html: htmlString }} />
    );
};

export default HtmlComp;
